/**
 * @fileoverview Category Card Component for Maintenance Checklist
 * @module CategoryCard
 */

import React from 'react';
import { ChevronRight, CheckCircle2, AlertCircle, Circle } from 'lucide-react';

interface CategoryCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  issueCount: number;
  isComplete: boolean;
  onClick: () => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({
  title,
  description,
  icon,
  issueCount,
  isComplete,
  onClick
}) => {
  return (
    <button
      onClick={onClick}
      className="w-full text-left bg-white rounded-xl border border-gray-200 p-6 hover:shadow-lg hover:border-blue-300 transition-all group"
    >
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-4">
          <div className={`p-3 rounded-lg ${
            isComplete 
              ? 'bg-green-50 text-green-600'
              : issueCount > 0 
                ? 'bg-amber-50 text-amber-600' 
                : 'bg-gray-100 text-gray-500'
          }`}>
            {icon}
          </div>
          <div>
            <h3 className="font-bold text-gray-900 text-lg group-hover:text-teal-600 transition-colors">
              {title}
            </h3>
            <p className="text-gray-600 text-sm mt-1">{description}</p>
            
            <div className="flex items-center gap-3 mt-3">
              {isComplete ? (
                <span className="flex items-center gap-1 text-green-600 text-sm font-medium">
                  <CheckCircle2 className="w-4 h-4" />
                  Complete
                </span>
              ) : issueCount > 0 ? (
                <span className="flex items-center gap-1 text-amber-600 text-sm font-medium">
                  <AlertCircle className="w-4 h-4" />
                  {issueCount} issue{issueCount !== 1 ? 's' : ''} documented
                </span>
              ) : (
                <span className="flex items-center gap-1 text-gray-500 text-sm">
                  <Circle className="w-4 h-4" />
                  Not started
                </span>
              )}
            </div>
          </div>
        </div>
        <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-teal-600 transition-colors" />
      </div>
    </button>
  );
};

export default CategoryCard;











